export default "__VITE_ASSET__292c5f3e__"